import { ImagesGridComponent } from './ImagesGrid';
export default ImagesGridComponent;
